<template>
  <div>
    <div class="text-body-1">Rum: {{ name }}</div>
  </div>
</template>

<script>
import { RecIndividual } from '@/rec-cache/rec-cache-individual'

import { Iris } from '@/rec-cache/rec-cache-types'

export default {
  props: {
    room: {
      type: Object,
      default: () => new RecIndividual(),
    },
  },
  computed: {
    type: function () {
      return this.room.type.short
    },
    name: function () {
      return this.room.getValuesByName(Iris.recName)?.[0]?.value || '-'
    },
  },
}
</script>
